export function getWrappedIndex(index: number, count: number) {
  return ((index % count) + count) % count;
}

export function clampValue(value: number, min: number, max: number) {
  return Math.max(min, Math.min(max, value));
}
